<agr-page-toolbar
  [pageTitle]="'nitrogenModelProperties.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'nitrogenModelProperties.addNitrogenModelProperty' | translate"
  (primaryAction)="createNitrogenModelProperty()"
>
  <div class="container">
    <agr-notification-empty
      [isEmpty]="!dataAvailable"
      [emptyDescription]="'nitrogenModelProperties.nitrogenModelPropertiesEmpty' | translate"
      emptyActionIcon="clear"
    >
      <mat-table [dataSource]="dataSource" data-test="nitrogen-model-property-table">
        <ng-container matColumnDef="nutrientDesignation">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.nutrientDesignation' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.nutrientDesignation }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilType">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.soilType' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilType.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilTargetUoM">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.soilTargetUoM' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.soilTargetUoM }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nBasebuffer">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.nBasebuffer' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.nBasebuffer }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxNbs">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.maxNbs' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.maxNbs }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxNbsSeedPotato">
          <mat-header-cell *matHeaderCellDef>{{
            'nitrogenModelProperties.maxNbsSeedPotato' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.maxNbsSeedPotato }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2"></mat-header-cell>
          <mat-cell *matCellDef="let item" class="flex--justify-end flex__child flex__child-2">
            <agr-responsive-actions
              [items]="nitrogenModelPropertiesActions"
              [showLabels]="false"
              (action)="nitrogenModelPropertiesAction($event, item.id)"
            ></agr-responsive-actions>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          data-test="nitrogen-model-properties-row"
        ></mat-row>
      </mat-table>
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
